module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/cic.65a59e28.png";